'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HotwaterIcon = function HotwaterIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M15 110h100v-2H15zM15 115h100v-2H15z'
                })
            ),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M37.825 61.143h4.02l.702 2.475v2.386h4.568v-3.97l1.988-1.555h1.493l1.937 2.08v3.445h4.951V62.56l1.892-1.416h1.996l1.604 2.099v2.762h4.627v-3.97l1.789-1.555h1.7l1.81 2.08v3.445h5.454v-3.97l1.464-1.555h1.375l2.084 1.555v3.97h4.198l.606-3.97 1.271-1.555h1.774l1.885 1.555v3.97h1.98l2.513-1.837h2.277l1.486 2.767v2.51l-.88 1.819-2.883.832-2.513-1.336-.65-2.095h-1.33v38.773l-1.885 1.278h-2.513l-1.138-2.54v-2.854H83.28v4.117l-2.084 1.277H79.82l-2.018-3.073v-2.321h-4.9v2.854l-1.205 2.54h-2.305l-1.79-2.54-.524-2.854h-3.341l-.76 2.321-.992 3.073h-3.814l-.687-3.073v-2.321h-4.951v2.854l-1.937 2.54h-2.425l-1.056-3.073v-2.321h-3.873l-.695 2.854-1.633 1.84h-3.09l-.643-2.373zM42 16h46v33H42z'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555',
                    fillRule: 'nonzero'
                },
                _react2.default.createElement('path', {
                    d: 'M39.449 107.5c.634 0 1.149-.56 1.149-1.25v-42.5c0-.69-.515-1.25-1.15-1.25-.634 0-1.149.56-1.149 1.25v42.5c0 .69.515 1.25 1.15 1.25zm0 2.5c-1.904 0-3.449-1.68-3.449-3.75v-42.5c0-2.07 1.545-3.75 3.449-3.75 1.903 0 3.448 1.68 3.448 3.75v42.5c0 2.07-1.545 3.75-3.448 3.75zM50.287 107.5c.634 0 1.15-.56 1.15-1.25v-42.5c0-.69-.516-1.25-1.15-1.25-.634 0-1.15.56-1.15 1.25v42.5c0 .69.516 1.25 1.15 1.25zm0 2.5c-1.904 0-3.449-1.68-3.449-3.75v-42.5c0-2.07 1.545-3.75 3.449-3.75s3.448 1.68 3.448 3.75v42.5c0 2.07-1.544 3.75-3.448 3.75zM60.14 107.5c.634 0 1.15-.56 1.15-1.25v-42.5c0-.69-.516-1.25-1.15-1.25-.634 0-1.15.56-1.15 1.25v42.5c0 .69.516 1.25 1.15 1.25zm0 2.5c-1.904 0-3.449-1.68-3.449-3.75v-42.5c0-2.07 1.545-3.75 3.449-3.75s3.448 1.68 3.448 3.75v42.5c0 2.07-1.544 3.75-3.448 3.75zM69.993 107.5c.634 0 1.15-.56 1.15-1.25v-42.5c0-.69-.516-1.25-1.15-1.25-.635 0-1.15.56-1.15 1.25v42.5c0 .69.515 1.25 1.15 1.25zm0 2.5c-1.904 0-3.449-1.68-3.449-3.75v-42.5c0-2.07 1.545-3.75 3.449-3.75s3.448 1.68 3.448 3.75v42.5c0 2.07-1.544 3.75-3.448 3.75zM79.846 107.5c.634 0 1.15-.56 1.15-1.25v-42.5c0-.69-.516-1.25-1.15-1.25-.635 0-1.15.56-1.15 1.25v42.5c0 .69.515 1.25 1.15 1.25zm0 2.5c-1.904 0-3.449-1.68-3.449-3.75v-42.5c0-2.07 1.545-3.75 3.449-3.75s3.448 1.68 3.448 3.75v42.5c0 2.07-1.544 3.75-3.448 3.75zM89.699 107.5c.634 0 1.149-.56 1.149-1.25v-42.5c0-.69-.515-1.25-1.15-1.25-.634 0-1.149.56-1.149 1.25v42.5c0 .69.515 1.25 1.15 1.25zm0 2.5c-1.904 0-3.449-1.68-3.449-3.75v-42.5c0-2.07 1.545-3.75 3.449-3.75 1.903 0 3.448 1.68 3.448 3.75v42.5c0 2.07-1.545 3.75-3.448 3.75z'
                }),
                _react2.default.createElement('path', {
                    d: 'M41.912 67.843v-2.941h4.926v2.941zM41.912 74.706v-2.941h4.926v2.94zM41.912 97.255v-2.941h4.926v2.94zM41.912 105.098v-2.941h4.926v2.941zM52.75 67.843v-2.941h4.926v2.941zM52.75 74.706v-2.941h4.926v2.94zM52.75 97.255v-2.941h4.926v2.94zM52.75 105.098v-2.941h4.926v2.941zM62.603 67.843v-2.941h4.926v2.941zM62.603 74.706v-2.941h4.926v2.94zM62.603 97.255v-2.941h4.926v2.94zM62.603 105.098v-2.941h4.926v2.941zM73.441 67.843v-2.941h4.927v2.941zM73.441 74.706v-2.941h4.927v2.94zM73.441 97.255v-2.941h4.927v2.94zM73.441 105.098v-2.941h4.927v2.941zM83.294 67.843v-2.941h4.927v2.941zM83.294 74.706v-2.941h4.927v2.94zM83.294 97.255v-2.941h4.927v2.94zM83.294 105.098v-2.941h4.927v2.941zM100.537 67.843a2.457 2.457 0 0 0-2.463-2.45 2.457 2.457 0 0 0-2.464 2.45 2.457 2.457 0 0 0 2.464 2.451 2.457 2.457 0 0 0 2.463-2.45zm2.463 0c0 2.708-2.205 4.902-4.926 4.902s-4.927-2.194-4.927-4.902c0-2.707 2.206-4.902 4.927-4.902 2.72 0 4.926 2.195 4.926 4.902z'
                })
            ),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555',
                    fillRule: 'nonzero'
                },
                _react2.default.createElement('path', {
                    d: 'M63.9 34.052h2.077V16.386H63.9zM60.697 34.14v-2.077h-6.272v2.077z'
                }),
                _react2.default.createElement('path', {
                    d: 'M59.897 21.581v12.47h2.078V19.505H45.262v14.548h2.078v-12.47zM75.511 34.14v-2.077H69.24v2.077z'
                }),
                _react2.default.createElement('path', {
                    d: 'M86.957 17.425v16.627h2.078V15.347H40.96v18.705h2.078V17.425z'
                }),
                _react2.default.createElement('path', {
                    d: 'M82.835 34.052h2.078V19.504H68.2v14.548h2.078v-12.47h12.557z'
                }),
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', {
                        d: 'M63.9 31.676h2.077v17.666H63.9zM59.897 44.146v-12.47h2.078v14.548H45.262V31.676h2.078v12.47z'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M86.957 48.303V31.676h2.078v18.705H40.96V31.676h2.078v16.627z'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M82.835 31.676h2.078v14.548H68.2V31.676h2.078v12.47h12.557z'
                    })
                )
            )
        )
    );
};

HotwaterIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var Hotwater = function (_React$Component) {
    _inherits(Hotwater, _React$Component);

    function Hotwater() {
        _classCallCheck(this, Hotwater);

        return _possibleConstructorReturn(this, (Hotwater.__proto__ || Object.getPrototypeOf(Hotwater)).apply(this, arguments));
    }

    _createClass(Hotwater, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(HotwaterIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return Hotwater;
}(_react2.default.Component);

exports.default = Hotwater;